import { Circle } from '@mui/icons-material'
import Chip from '@mui/material/Chip'
import Typography from '@mui/material/Typography'

interface Props {
  isResolved: boolean
  wasChildCreated?: boolean
}

interface ChipProperties {
  style: React.CSSProperties
  label: string
}

export function ResolvedChip (props: Props): JSX.Element {
  const { isResolved, wasChildCreated } = props

  function getChipProperties (): ChipProperties {
    if (isResolved) {
      if (wasChildCreated === true) {
        return {
          style: {
            border: '1px solid #2c8642',
            background: 'rgba(51, 148, 64, 0.1)',
            color: '#3c9630'
          },
          label: 'Resolved With Child Creation'
        }
      } else {
        return {
          style: {
            border: '1px solid #4640a5',
            background: 'rgba(78, 76, 190, 0.1)',
            color: '#4648be'
          },
          label: 'Resolved Without Child Creation'
        }
      }
    } else {
      return {
        style: {
          border: '1px solid #BC3656',
          background: 'rgba(188, 54, 86, 0.1)',
          color: '#BC3656'
        },
        label: 'Unresolved'
      }
    }
  }

  const chipProperties = getChipProperties()

  return <Chip
    icon={<Circle sx={{ fontSize: 11, color: `${chipProperties.style.color ?? 'black'} !important` }} />}
    label={<Typography sx={{ fontWeight: '600', fontSize: '14px' }}>{chipProperties.label}</Typography>}
    variant='outlined'
    sx={{ ...chipProperties.style, paddingX: '12px' }}
  />
}
